// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.picklist {
  min-height: 89vh;
  overflow: auto;
}
.picklist::-webkit-scrollbar {
  width: 0.7em;
  height: 0.7em;
}
.picklist::-webkit-scrollbar-thumb {
  background: #2c53a0;
}
.picklist::-webkit-scrollbar-track {
  background: #96a9d0;
}
.picklist {
  scrollbar-face-color: #2c53a0;
  scrollbar-track-color: #96a9d0;
}
@media (max-width: 600px) {
  .picklist::-webkit-scrollbar {
    width: 0em;
    height: 0em;
  }
  .picklist::-webkit-scrollbar-thumb {
    background: #fff;
  }
  .picklist::-webkit-scrollbar-track {
    background: white;
  }
  .picklist {
    scrollbar-face-color: #fff;
    scrollbar-track-color: white;
  }
}
@media (max-width: 1000px) {
  .picklist .table td:nth-of-type(1):before {
    content: "From";
  }
  .picklist .table td:nth-of-type(2):before {
    content: "To";
  }
  .picklist .table td:nth-of-type(3):before {
    content: "Supplier";
  }
  .picklist .table td:nth-of-type(4):before {
    content: "Product Total";
  }
  .picklist .table td:nth-of-type(5):before {
    content: "Status";
  }
  .picklist .table td:nth-of-type(6):before {
    content: "Date Created";
  }
}
.picklist .table tbody tr:hover {
  background-color: #e4ffff;
  cursor: pointer;
}
.picklist .pagination_btns {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  gap: 1vw;
  margin: 1vh auto;
  width: 95vw;
}
.picklist .pagination_btns button {
  width: 100%;
}

.individual_picklist {
  height: 89vh;
  overflow: auto;
}
.individual_picklist::-webkit-scrollbar {
  width: 0.7em;
  height: 0.7em;
}
.individual_picklist::-webkit-scrollbar-thumb {
  background: #2c53a0;
}
.individual_picklist::-webkit-scrollbar-track {
  background: #96a9d0;
}
.individual_picklist {
  scrollbar-face-color: #2c53a0;
  scrollbar-track-color: #96a9d0;
}
@media (max-width: 600px) {
  .individual_picklist::-webkit-scrollbar {
    width: 0em;
    height: 0em;
  }
  .individual_picklist::-webkit-scrollbar-thumb {
    background: #fff;
  }
  .individual_picklist::-webkit-scrollbar-track {
    background: white;
  }
  .individual_picklist {
    scrollbar-face-color: #fff;
    scrollbar-track-color: white;
  }
}
.individual_picklist .page_section {
  width: 95vw;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: "row";
  gap: "10px";
  margin: 0 auto;
  font-size: 1.2rem;
}
.individual_picklist .page_section h3 span {
  color: #2c53a0;
}
@media (max-width: 1000px) {
  .individual_picklist .page_section {
    margin-bottom: -5%;
  }
}
.individual_picklist .table .product_image_mobile {
  display: none;
}
.individual_picklist .table .image_on_desktop img {
  width: 100%;
  max-width: 100px;
}
.individual_picklist .table .product_name {
  font-size: 1.3rem;
}
.individual_picklist .table td {
  height: 10vh;
}
.individual_picklist .table td .info_btn {
  font-size: 2rem;
  color: #2c53a0;
}
@media (max-width: 1000px) {
  .individual_picklist .table .product_name {
    font-size: 2rem;
    margin-right: -30%;
  }
  .individual_picklist .table td:nth-of-type(1) {
    height: 20vh;
  }
  .individual_picklist .table td:nth-of-type(2),
  .individual_picklist .table td:nth-of-type(3),
  .individual_picklist .table td:nth-of-type(5) {
    height: 8vh;
  }
  .individual_picklist .table td:nth-of-type(1):before {
    content: "Product";
    height: 20vh;
  }
  .individual_picklist .table td:nth-of-type(2):before {
    content: "Ordered";
  }
  .individual_picklist .table td:nth-of-type(3):before {
    content: "Picked";
  }
  .individual_picklist .table td:nth-of-type(5):before {
    content: "Done";
  }
  .individual_picklist .table .product_image_mobile {
    display: flex;
    width: 100%;
    max-width: 250px;
    margin: 1vh auto;
  }
  .individual_picklist .table .image_on_desktop {
    display: none;
  }
  .individual_picklist .table tr td {
    box-shadow: 0 4px 2px -2px #2c53a0;
  }
  .individual_picklist .table tr td,
  .individual_picklist .table tr td:before {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: "row";
    gap: "10px";
    height: 15vh;
    overflow-y: none;
    font-weight: 700;
    font-size: 1.2rem;
    word-wrap: break-word;
    overflow-wrap: inherit;
  }
  .individual_picklist .table tr td:before {
    width: auto;
    padding-left: 10px;
  }
  .individual_picklist .table tr button,
  .individual_picklist .table tr .input_number {
    height: 9vh;
    width: 100%;
  }
  .individual_picklist .table tr .input_number {
    height: 6vh;
    font-size: 1.2rem;
    font-weight: 700;
    color: #2c53a0;
  }
}
.individual_picklist .nav_btns {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  gap: 1vw;
  width: 95vw;
  margin: 0 auto;
}
.individual_picklist .nav_btns button {
  width: 100%;
  height: 8vh;
}
.individual_picklist .button_section {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  gap: 1vw;
  height: 10vh;
}
.individual_picklist .button_section button {
  width: 95vw;
}
@media (max-width: 1000px) {
  .individual_picklist .button_section {
    margin: 4vh 0;
  }
  .individual_picklist .button_section button {
    height: 10vh;
  }
}

.confirm_row_dialog {
  width: 90vw;
  margin: 0 auto;
  text-align: center;
}
.confirm_row_dialog .confirm_row_header {
  font-weight: 700;
}
.confirm_row_dialog .confirm_row_content {
  font-size: 1.2rem;
  padding: 20px;
}
.confirm_row_dialog .confirm_row_btns {
  width: 95%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  gap: 10px;
  margin: 1vh auto;
}
.confirm_row_dialog .confirm_row_btns button {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/picklist/picklist.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AACA;EACI,gBCYU;EDXV,cAAA;AAAJ;ACwCI;EACI,YDxCgB;ECyChB,aDzCgB;AAGxB;ACyCI;EACI,mBAhDI;ADSZ;AC0CI;EACI,mBAbe;AD3BvB;AC4CI;EACI,6BAzDI;EA0DJ,8BAnBe;ADvBvB;AAZI;ECsCA;IACI,UDtCoB;ICuCpB,WDvCoB;EAgB1B;EC0BE;IACI,gBA1CA;EDkBN;EC2BE;IACI,iBAbe;EDZrB;EC6BE;IACI,0BAnDA;IAoDA,4BAnBe;EDRrB;AACF;AAvBQ;EACI;IACI,eAAA;EAyBd;EAvBU;IACI,aAAA;EAyBd;EAvBU;IACI,mBAAA;EAyBd;EAvBU;IACI,wBAAA;EAyBd;EAvBU;IACI,iBAAA;EAyBd;EAvBU;IACI,uBAAA;EAyBd;AACF;AArBY;EACI,yBC9BH;ED+BG,eAAA;AAuBhB;AAlBI;ECVA,aAAA;EACA,8BDUkB;ECTlB,mBDSiC;ECRjC,mBDQyC;ECPzC,QDO8C;EAC1C,gBAAA;EACA,WAAA;AAwBR;AAvBQ;EACI,WAAA;AAyBZ;;AApBA;EACI,YCpCU;EDqCV,cAAA;AAuBJ;AC/BI;EACI,YDSgB;ECRhB,aDQgB;AAyBxB;AC9BI;EACI,mBAhDI;ADgFZ;AC7BI;EACI,mBAbe;AD4CvB;AC3BI;EACI,6BAzDI;EA0DJ,8BAnBe;ADgDvB;AAlCI;ECXA;IACI,UDWoB;ICVpB,WDUoB;EAsC1B;EC7CE;IACI,gBA1CA;EDyFN;EC5CE;IACI,iBAbe;ED2DrB;EC1CE;IACI,0BAnDA;IAoDA,4BAnBe;ED+DrB;AACF;AA9CI;EACI,WAAA;EC9BJ,aAAA;EACA,8BD8BkB;EC7BlB,mBD6BiC;EC5BjC,qBANY;EAOZ,WANM;EDkCF,cAAA;EACA,iBAAA;AAoDR;AAlDY;EACI,cChEJ;ADoHZ;AAjDQ;EAVJ;IAWQ,kBAAA;EAoDV;AACF;AAhDQ;EACI,aAAA;AAkDZ;AA/CY;EACI,WAAA;EACA,gBAAA;AAiDhB;AA9CQ;EACI,iBAAA;AAgDZ;AA9CQ;EACI,YAAA;AAgDZ;AA/CY;EACI,eAAA;EACA,cCzFJ;AD0IZ;AA9CQ;EACI;IACI,eAAA;IACA,kBAAA;EAgDd;EA9CU;IACI,YAAA;EAgDd;EA9CU;;;IAGI,WAAA;EAgDd;EA9CU;IACI,kBAAA;IACA,YAAA;EAgDd;EA7CU;IACI,kBAAA;EA+Cd;EA7CU;IACI,iBAAA;EA+Cd;EA7CU;IACI,eAAA;EA+Cd;EA7CU;IACI,aAAA;IACA,WAAA;IACA,gBAAA;IACA,gBAAA;EA+Cd;EA7CU;IACI,aAAA;EA+Cd;EA5Cc;IACI,kCAAA;EA8ClB;EA5Cc;;ICxGZ,aAAA;IACA,uBDyG8B;ICxG9B,mBDwGsC;ICvGtC,qBANY;IAOZ,WANM;ID6GU,YAAA;IACA,gBAAA;IACA,gBAAA;IACA,iBAAA;IACA,qBAAA;IACA,sBAAA;EAkDlB;EAhDc;IACI,WAAA;IACA,kBAAA;EAkDlB;EA/Cc;;IAEI,WAAA;IACA,WAAA;EAiDlB;EA/Cc;IACI,WAAA;IACA,iBAAA;IACA,gBAAA;IACA,cC5JR;ED6MV;AACF;AA5CI;ECtIA,aAAA;EACA,8BDsIkB;ECrIlB,mBDqIiC;ECpIjC,mBDoIyC;ECnIzC,QDmI8C;EAC1C,WAAA;EACA,cAAA;AAkDR;AAjDQ;EACI,WAAA;EACA,WAAA;AAmDZ;AA/CI;EChJA,aAAA;EACA,uBDgJkB;EC/IlB,mBD+I0B;EC9I1B,mBD8IkC;EC7IlC,QD6IuC;EACnC,YAAA;AAqDR;AApDQ;EACI,WAAA;AAsDZ;AApDQ;EANJ;IAOQ,aAAA;EAuDV;EAtDU;IACI,YAAA;EAwDd;AACF;;AAnDA;EACI,WAAA;EACA,cAAA;EACA,kBAAA;AAsDJ;AArDI;EACI,gBAAA;AAuDR;AApDI;EACI,iBAAA;EACA,aAAA;AAsDR;AAnDI;EACI,UAAA;EC7KJ,aAAA;EACA,8BD6KkB;EC5KlB,mBD4KiC;EC3KjC,mBD2KyC;EC1KzC,SD0K8C;EAC1C,gBAAA;AAyDR;AAxDQ;EACI,WAAA;AA0DZ","sourcesContent":["@import \"../../variables.scss\";\n.picklist {\n    min-height: $main-height;\n    overflow: auto;\n    @include scrollbars(0.7em, $nitroDark);\n    @media (max-width: $mobile) {\n        @include scrollbars(0em, $white);\n    }\n\n    .table {\n        @media (max-width: $tablet) {\n            td:nth-of-type(1):before {\n                content: \"From\";\n            }\n            td:nth-of-type(2):before {\n                content: \"To\";\n            }\n            td:nth-of-type(3):before {\n                content: \"Supplier\";\n            }\n            td:nth-of-type(4):before {\n                content: \"Product Total\";\n            }\n            td:nth-of-type(5):before {\n                content: \"Status\";\n            }\n            td:nth-of-type(6):before {\n                content: \"Date Created\";\n            }\n        }\n\n        tbody {\n            tr:hover {\n                background-color: $background;\n                cursor: pointer;\n            }\n        }\n    }\n\n    .pagination_btns {\n        @include flex(space-between, center, row, 1vw);\n        margin: 1vh auto;\n        width: 95vw;\n        button {\n            width: 100%;\n        }\n    }\n}\n\n.individual_picklist {\n    height: $main-height;\n    overflow: auto;\n\n    @include scrollbars(0.7em, $nitroDark);\n    @media (max-width: $mobile) {\n        @include scrollbars(0em, $white);\n    }\n\n    .page_section {\n        width: 95vw;\n        @include flex(space-between, center);\n        margin: 0 auto;\n        font-size: 1.2rem;\n        h3 {\n            span {\n                color: $nitroDark;\n            }\n        }\n        @media (max-width: $tablet) {\n            margin-bottom: -5%;\n        }\n    }\n\n    .table {\n        .product_image_mobile {\n            display: none;\n        }\n        .image_on_desktop {\n            img {\n                width: 100%;\n                max-width: 100px;\n            }\n        }\n        .product_name {\n            font-size: 1.3rem;\n        }\n        td {\n            height: 10vh;\n            .info_btn {\n                font-size: 2rem;\n                color: $nitroDark;\n            }\n        }\n        @media (max-width: $tablet) {\n            .product_name {\n                font-size: 2rem;\n                margin-right: -30%;\n            }\n            td:nth-of-type(1) {\n                height: 20vh;\n            }\n            td:nth-of-type(2),\n            td:nth-of-type(3),\n            td:nth-of-type(5) {\n                height: 8vh;\n            }\n            td:nth-of-type(1):before {\n                content: \"Product\";\n                height: 20vh;\n            }\n\n            td:nth-of-type(2):before {\n                content: \"Ordered\";\n            }\n            td:nth-of-type(3):before {\n                content: \"Picked\";\n            }\n            td:nth-of-type(5):before {\n                content: \"Done\";\n            }\n            .product_image_mobile {\n                display: flex;\n                width: 100%;\n                max-width: 250px;\n                margin: 1vh auto;\n            }\n            .image_on_desktop {\n                display: none;\n            }\n            tr {\n                td {\n                    box-shadow: 0 4px 2px -2px $nitroDark;\n                }\n                td,\n                td:before {\n                    @include flex(center, center);\n                    height: 15vh;\n                    overflow-y: none;\n                    font-weight: 700;\n                    font-size: 1.2rem;\n                    word-wrap: break-word;\n                    overflow-wrap: inherit;\n                }\n                td:before {\n                    width: auto;\n                    padding-left: 10px;\n                }\n\n                button,\n                .input_number {\n                    height: 9vh;\n                    width: 100%;\n                }\n                .input_number {\n                    height: 6vh;\n                    font-size: 1.2rem;\n                    font-weight: 700;\n                    color: $nitroDark;\n                }\n            }\n        }\n    }\n\n    .nav_btns {\n        @include flex(space-between, center, row, 1vw);\n        width: 95vw;\n        margin: 0 auto;\n        button {\n            width: 100%;\n            height: 8vh;\n        }\n    }\n\n    .button_section {\n        @include flex(center, center, row, 1vw);\n        height: 10vh;\n        button {\n            width: 95vw;\n        }\n        @media (max-width: $tablet) {\n            margin: 4vh 0;\n            button {\n                height: 10vh;\n            }\n        }\n    }\n}\n\n.confirm_row_dialog {\n    width: 90vw;\n    margin: 0 auto;\n    text-align: center;\n    .confirm_row_header {\n        font-weight: 700;\n    }\n\n    .confirm_row_content {\n        font-size: 1.2rem;\n        padding: 20px;\n    }\n\n    .confirm_row_btns {\n        width: 95%;\n        @include flex(space-between, center, row, 10px);\n        margin: 1vh auto;\n        button {\n            width: 100%;\n        }\n    }\n}\n","//Colors\n$nitroDark: #2c53a0;\n$nitroLight: #64c4e0;\n$background: #e4ffff;\n$fontColor: #4d4d4d;\n$error: #bb0000;\n$warning: #f29422;\n$white: #fff;\n$black: #000;\n$success: #b6fcc9;\n$green: #357a38;\n\n//Heights\n$nav-height: 10vh;\n$main-height: 89vh;\n$footer-height: 6vh;\n\n//Breakpoints\n$mobile: 600px;\n$tablet: 1000px;\n$desktop: 1300px;\n\n//Layout\n@mixin flex(\n    $justify: \"center\",\n    $align: \"center\",\n    $direction: \"row\",\n    $gap: \"10px\"\n) {\n    display: flex;\n    justify-content: $justify;\n    align-items: $align;\n    flex-direction: $direction;\n    gap: $gap;\n}\n\n//Overflow\n@mixin scrollbars(\n    $size,\n    $foreground-color,\n    $background-color: mix($foreground-color, white, 50%)\n) {\n    // For Google Chrome\n    &::-webkit-scrollbar {\n        width: $size;\n        height: $size;\n    }\n\n    &::-webkit-scrollbar-thumb {\n        background: $foreground-color;\n    }\n\n    &::-webkit-scrollbar-track {\n        background: $background-color;\n    }\n\n    // For Internet Explorer\n    & {\n        scrollbar-face-color: $foreground-color;\n        scrollbar-track-color: $background-color;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
